import * as XLSX from 'xlsx';
import { CustomerReportColumn,CustomerReportData } from '../../models/all-user/edit-user-model';

export const exportCustomerReport = (
  columns: CustomerReportColumn[],
  data: CustomerReportData[],
  filename: string = 'CustomerReportExport.xlsx'
) => {
  const flatData = data.map(item => {
    const row: Record<string, string | number> = {};
    columns.forEach(col => {
      row[col.name.replace(/_/g, ' ')] = item[col.name]; 
    });
    return row;
  });

  const worksheet = XLSX.utils.json_to_sheet(flatData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Customer Report');

  XLSX.writeFile(workbook, filename);
};
